export { default } from './ErrorBoundary';
export type { ErrorBoundaryProps } from './types';
